export const isDevelopmentMode = import.meta.env.DEV;
